import { computed } from 'vue';
import { LoadingStatuses } from '@/models/loading.interface';
import store from '@/store';

export default class AuditorEntriesOverviewCode {

	public isLoading = computed((): boolean => {
		return this.isPricingProductsDataLoading.value || this.isAuditorDataLoading.value;
	});

	private isPricingProductsDataLoading = computed((): boolean => {
		const loadingStatus = store.getters.loadingStatusPricingProducts();
		return loadingStatus === LoadingStatuses.ACTIVE;
	});

	private isAuditorDataLoading = computed((): boolean => {
		const loadingStatus = store.getters.loadingStatusAuditorEntries();
		return loadingStatus === LoadingStatuses.ACTIVE;
	});
}
